export default "__VITE_ASSET__B30heOWc__"